import { render, staticRenderFns } from "./JobPostingsNew.vue?vue&type=template&id=63b848fc&scoped=true"
import script from "./JobPostingsNew.vue?vue&type=script&lang=ts"
export * from "./JobPostingsNew.vue?vue&type=script&lang=ts"
import style0 from "./JobPostingsNew.vue?vue&type=style&index=0&id=63b848fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b848fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b848fc')) {
      api.createRecord('63b848fc', component.options)
    } else {
      api.reload('63b848fc', component.options)
    }
    module.hot.accept("./JobPostingsNew.vue?vue&type=template&id=63b848fc&scoped=true", function () {
      api.rerender('63b848fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/managerDetails/JobPostingsNew.vue"
export default component.exports